<template>
  <div class="index container">
    <div class="card white" v-for="recipe in recipes" :key="recipe.id">
      <div class="card-content">
        <i class="material-icons delete red-text text-lighten-3" @click="deleteRecipe(recipe.id)">delete</i>
        <h2 class="blue-grey-text text-darken-4">{{ recipe.title }}</h2>
        <ul class="ingredients">
          <li v-for="(ingredient, index) in recipe.ingredients" :key="index">
            <span class="chip white-text brown lighten-1">{{ ingredient }}</span>
          </li>
        </ul>
      </div>
      <span class="btn-floating btn-small halfway-fab light-green darken-4">
        <router-link :to="{ name: 'EditRecipe', params: {recipe_slug: recipe.slug}}">
          <i class="material-icons edit">edit</i>
        </router-link>
      </span>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init"
export default {
  name: 'Index',
  data () {
    return {
      recipes: []
    }
  },
  methods: {
    deleteRecipe(id) {
      // delete document from firestore
      db.collection("recipes").doc(id).delete()
      .then(() => {

      })
      this.recipes = this.recipes.filter(recipe => {
        return recipe.id != id
      })
    }
  },
  created() {
    // Retrieve data from db
    db.collection("recipes").get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        let recipe = doc.data()
        recipe.id = doc.id
        this.recipes.push(recipe)
      })
    })
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Kalam');

  .index {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    margin-top: 40px;
    justify-content: space-around;
    grid-gap: 20px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 30px;
  }
  .index h2 {
    font-size: 1.8em;
    text-align: center;
    margin-top: 40px;
    font-family: 'Kalam', cursive;
  }
  .index .ingredients {
    margin: 30px auto;
    text-align: center;
  }
  .index .ingredients li {
    display: inline-block;
  }
  .index .delete {
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    color: #aaa;
    font-size: 1.4em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue